<div class="user-profile">
    <f-button [text]="rootScope.name" type="button" variant="progressive" (click)="showDataCard()" class="pink">
    </f-button>
    <div class="user-profile-dialog" *ngIf="finalShowProfileCardVal && rootScope.loadUI">
        <f-data-card>

            <div class="flex justify-flex-end close-button">
                <button mat-icon-button aria-label="" (click)="closeDataCard()">
                    <f-icon [iconConfig]="iconConfig"></f-icon>
                </button>
            </div>
            <h4 class="my-account-title"> My Account</h4>
            <p class="name"> {{rootScope.firstName + " " + rootScope.lastName}}</p>


            <!-- Database Selector code start here  -->
            <div class="database-selector profile-link" *ngIf="!this.rootScope.isCarePortalProd">
                <p title="Database Selector">
                    <span *ngIf="rootScope.isLiveCall || rootScope.isLiveChat"> <i
                            class="fa-light fa-database gap gray"></i></span>
                    <span *ngIf="!rootScope.isLiveCall && !rootScope.isLiveChat"> <i
                            class="fa-light fa-database gap"></i></span>
                    <f-button text="Database Selector"
                        [ngClass]="{'disabledLink': this.rootScope.isLiveCall || this.rootScope.isLiveChat}"
                        type="button" variant="action" class="no-border" (click)="openDatabaseSelector()">
                    </f-button>
                </p>
            </div>


            <div class="section-divider"></div>

            <!-- Batch alert code start here  -->
            <div class="batch-alert profile-link toggle-CTA hide">
                <div title="Batch Alerts"><i class="fa-light fa-bell gap"></i>
                    <f-button text="Batch Alerts" type="button" variant="action" class="no-border"
                        (click)="openbatchAlert()">
                    </f-button>
                </div>

                <!-- add "disabledLink" class with "toggle-btn" to make it disable  -->
                <div class="toggle-btn">
                    <span>Off</span>
                    <mat-slide-toggle [disabled]="checkTogglediasabled()"
                        title="Use the Toggle key to turn the Batch Alert On/Off.">On</mat-slide-toggle>
                </div>
            </div>

            <!-- simulation-mode code start here  -->
            <div class="simulation-mode toggle-CTA hide1" *ngIf="this.rootScope.simulationData.isSimulationAccess">
                <div class="sm-selector">
                    <f-tooltip content="To access Simulation Mode, user can't be registered to ALIS organization."
                        position="left" variant="info"></f-tooltip>

                    <span> Simulation Mode </span>
                </div>

                <!-- add "disabledLink" class with "toggle-btn" to make it disable  -->
                <div class="toggle-btn">
                    <span>Off</span>
                    <mat-slide-toggle [(ngModel)]="this.rootScope.simulationData.isSimulationToggleOn"
                        [disabled]="checkTogglediasabled()" (change)="onToggleChange($event)"
                        title="Use the Toggle key to turn the Simulation Mode On/Off.">On</mat-slide-toggle>
                </div>
            </div>

            <div class="section-divider"></div>

            <p class="profile-link help">
                <i class="fa-light fa-circle-question gap"></i>
                <!-- <button title='Help' (click)="openHelpPdf()" title="Help">Help</button> -->
                <f-button text="Help" type="button" variant="action" class="no-border" (click)="openHelpPdf()">
                </f-button>
            </p>

            <p class="profile-link logout"><i class="fa-light fa-arrow-right-from-bracket gap"></i>
                <f-button text="Logout" type="button" variant="action" class="no-border" (click)="userLogout()">
                </f-button>
            </p>
            <div class="text-align-center disclaimer">
                <div class="version-text"> {{"Version " + showAngularVersion}}</div>
                <div> &copy; 2024 Alight. All rights reserved.</div>
                <div class="trademark">&reg; Alight is a registered trademark of Alight Solutions, LLC</div>
                <div class="link"><button class='navlink' title="Privacy and Policies"
                        (click)="openPrivacyLink()">Privacy and
                        Policies</button></div>
                <div class="timestamp"> {{showTimeStamp | date:'medium'}} || {{showFullHash.slice(-8)}}</div>
            </div>
        </f-data-card>
    </div>
</div>